<template>
    <div class="scopusDetails">
        <Detail>
            <template>
                <h2 v-html="data.ti"></h2>
                <div>
                    <p>
                        <span>作者:</span>
                        {{ data.au }}
                    </p>
                    <p>
                        <span>来源:</span>
                        {{ data.so }}
                    </p>
                    <p>
                        <span>日期:</span>
                        {{ data.py }}
                        {{data.volumeIssue}}
                    </p>
                    <p style="border-bottom:1px dashed;padding-bottom:0.5rem;margin-bottom:1rem;">
                        <span>摘要:</span>
                        {{ data.ab }}
                    </p>
                </div>
            </template>
        </Detail>
    </div>
</template>

<script>
import { Toast } from 'vant';
import Detail from '@/components/detail.vue'
export default {
  name: "scopusdetail",
  data () {
    return {
      data: {}
    }
  },
  components: {
    Detail
  },
  mounted () {
    this.$get('scopus/detail?url=' + encodeURIComponent(this.$route.query.url.split('?token')[0])).then(res => {
      if (res.code === 0) {
        this.data = res.data;
        // this.ab = res.data.ab;
        // this.au = res.data.au;
        // this.downloadUrl = res.data.downloadUrl;
        // this.py = res.data.py;
        // this.ti = res.data.ti;
        // this.so = res.data.so;
        // this.volumeIssue = res.data.volumeIssue;
      } else {
        Toast(res.msg)
      }
    });
  },
  methods: {},

}
</script>

<style scoped>
.box {
  height: auto;
  display: table;
  width: 96%;
  margin: 0 auto;
}

.ti {
  width: 100%;
  font-size: 20px;
  text-align: center;
}

.au {
  margin-top: 15px;
  width: auto;
  display: table;
  font-size: 16px;
}

.au span {
  margin-left: 10px;
  float: left;
  line-height: 35px;
}

.ab {
  text-indent: 2em;
  margin-top: 15px;
  padding: 10px;
  font-size: 16px;
  line-height: 35px;
}

.pdf_box {
  width: 100%;
  margin: 30px auto;
}

.pdf {
  width: 98%;
  height: 45px;
  color: white;
  border: none;
  border-radius: 4px;
  background-color: #1771a2;
}
</style>
